<template>
  <div style="padding-top: 90px;" v-loading="loading" element-loading-background="rgba(17, 17, 17, 0.8)">
   
    <el-row>

      <div class="size-body">

        <div>
          <div style="margin: 0px;">
            <!-- 广告 -->
            <el-row :gutter="0">

              <el-col :xs="12*item.span" :sm="6*item.span" :md="6*item.span" :lg="4*item.span" v-for="(item,index) in adlist" :key="index"><!-- style="margin-bottom: -10px" -->

                <a :href="item.url" target="_blank">
                  <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;padding: 0 2px;" class="" :src="item.image" fit="cover" >
                    <template #error>
                      <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                    </template>
                  </el-image>
                </a>

              </el-col>

            </el-row>
          </div>

          <!-- <div class="title-s">
            
          </div> -->

          <el-row :span="24" :gutter="0" style="padding: 10px;min-height: 200px;" class="row-bg">
            <el-col :xs="12" :sm="8" :lg="4" class="card" style="position: relative;" v-for="(item,index) in List" :key="index" >
              
                <!-- <span v-if="item.ending==0" class="ending">완결</span>
                <span v-else class="ending">제 {{ item.ending }} 화</span> -->

                <span :class="index>3?'flag2':'flag'"></span>
                <span class="flagNum font_tsdr">{{ index + 1 }}</span>
                
                <router-link :to="'/Detail?id='+item.id">

                    <el-card shadow="hover" :body-style="{ padding: '0px', width: '100%' }"
                        style="margin: 6px 8px;border: 0;border-radius: 5px 5px 0 0;background-color: transparent;">
                        <span>
                        <el-image style="width: 100%; aspect-ratio: 9/13;border-radius: 5px;text-align: center;" :src="item.image" fit="cover">
                            <div slot="error">
                            <img src="@/assets/no_img.png" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                                fit="cover">
                            </div>
                            <div slot="placeholder">
                            <img src="@/assets/loading.gif" style="width: 100%; aspect-ratio: 9/13;text-align: center;"
                                fit="cover">
                            </div>
                        </el-image>
                        </span>
                        

                        <div style="padding: 3px 0;min-height: 40px;">
                        <el-tooltip transition="" effect="dark" :content="item.intor" placement="top">
                            <div class="one_line" style="color: #ddd;font-size: 0.9rem;width:100%;text-align: left;">
                            <div>{{ item.title }}</div>
                            <div>{{ item.star }}</div>
                            </div>
                        </el-tooltip>
                        </div>

                    </el-card>

                </router-link>

            </el-col>
          </el-row>
        </div>


      </div>


    </el-row>

  </div>
</template>

<script>
export default {
  name: 'TopView',
  components: {
  },
  data() {
    return {
      loading:true,
      adlist:[],
      List:[]
    };
  },
  created() {
    this.loadPage()
  },
  mounted() {
    var element = document.getElementById('pagetop');
          element.scrollIntoView({ behavior: "smooth" });
  },
  watch: {
    // 监听路由对象 $route 的变化
    '$route': {
      handler: function (to, from) {
        // 路由变化时执行的操作
        this.loading = true

        var element = document.getElementById('pagetop');
            element.scrollIntoView({ behavior: "smooth" });

        this.loadPage()
      },
      // 设置为深度监听
      deep: true
    }
  },
  methods: {
    loadPage() {
      var this_ = this
      this.httpinfo.GetInfo(this,this.baseURL + "search_top?mark="+this.baseMark, function(e) {
        if(e.data.code==0){
          
          this_.List = e.data.data.list

          let Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
          e.data.data.adlist.forEach(function(item){
            if(item.rand=='0'){
              Temp_Rand_Arr.push(item)
            }else{
              Temp_No_Rand_Arr.push(item)
            }
          })
          Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置

          Temp_No_Rand_Arr.forEach(function(item){
            Temp_Rand_Arr.splice(item.location_num-1,0,item)
          })
          this_.adlist = Temp_Rand_Arr

          this_.loading = false

        }else{
          
          this_.$message.error(e.data.msg)

        }

      });
    },
  }
}
</script>
<style>
.flag{
  z-index: 9;
  color: #FFF;
  /* font-weight: bold; */
  /* font-size: 11px; */
  position: absolute;
  top: 6px; 
  left: 8px; 
  /* line-height: 30px; */
  /* text-align: center; */
  width: 0; /* 设置容器宽度为0 */
  height: 0; /* 设置容器高度为0 */
  border-left: 23px solid #F56C6C; /* 左下角 */
  border-top: 23px solid #F56C6C; /* 左上角 */
  border-right: 23px solid transparent; /* 右上角 */
  border-bottom: 23px solid transparent; /* 右下角 */
  border-radius: 8px 0 0 0;
}
.flag2{
  z-index: 9;
  color: #FFF;
  /* font-weight: bold; */
  /* font-size: 11px; */
  position: absolute;
  top: 6px; 
  left: 8px;
  /* line-height: 30px; */
  /* text-align: center; */
  width: 0; /* 设置容器宽度为0 */
  height: 0; /* 设置容器高度为0 */
  border-left: 23px solid #AAA; /* 左下角 */
  border-top: 23px solid #AAA; /* 左上角 */
  border-right: 23px solid transparent; /* 右上角 */
  border-bottom: 23px solid transparent; /* 右下角 */
  border-radius: 8px 0 0 0;
}
.flagNum{
  z-index: 10;
  position:absolute;
  padding: 9px 12px;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  color: #FFF;
  left: 0;
  /* font-family: '(한)문화방송';
  src: url('~@/assets/fonts/mhbson.ttf') format('truetype'); */
  font-weight: normal;
  font-style: normal;
}
</style>
